'use strict';

var ServiceAdjustmentTimeOfDayAggregationFactory = function ServiceAdjustmentTimeOfDayAggregationFactory(DataAggregationFactory) {
  function ServiceAdjustmentTimeOfDayAggregation() {
    DataAggregationFactory.call(this, 'service-share', 'demand-adjustment-time-of-day');
  }
  ServiceAdjustmentTimeOfDayAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  ServiceAdjustmentTimeOfDayAggregation.constructor = ServiceAdjustmentTimeOfDayAggregation;
  ServiceAdjustmentTimeOfDayAggregation.prototype.aggregate = function (data) {
    var groupedDepartureDateMomentTimeOfDay = {};
    var groupedDepartureDateMomentTimeOfDayUnordered = {};
    for (var index = 0, dataLength = data.length; index < dataLength; index++) {
      var item = data[index];
      if (!groupedDepartureDateMomentTimeOfDayUnordered[item.departureDateMomentTimeOfDay]) {
        groupedDepartureDateMomentTimeOfDayUnordered[item.departureDateMomentTimeOfDay] = [];
      }
      groupedDepartureDateMomentTimeOfDayUnordered[item.departureDateMomentTimeOfDay].push(item);
    }
    var groupedDepartureDateMomentTimeOfDayKeys = Object.keys(groupedDepartureDateMomentTimeOfDayUnordered).sort();
    index = 0;
    for (var keysLength = groupedDepartureDateMomentTimeOfDayKeys.length; index < keysLength; index++) {
      groupedDepartureDateMomentTimeOfDay[groupedDepartureDateMomentTimeOfDayKeys[index]] = groupedDepartureDateMomentTimeOfDayUnordered[groupedDepartureDateMomentTimeOfDayKeys[index]];
    }
    return groupedDepartureDateMomentTimeOfDay;
  };
  return ServiceAdjustmentTimeOfDayAggregation;
};
ServiceAdjustmentTimeOfDayAggregationFactory.$inject = ['DataAggregationFactory'];
module.exports = ServiceAdjustmentTimeOfDayAggregationFactory;